export function toDatetimeLocal(date) {
  const d = new Date(date);
  const pad = (value) => String(value).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function defaultBookingForm() {
  const start = new Date(Date.now() + 60 * 60 * 1000);
  start.setMinutes(0, 0, 0);
  const end = new Date(start.getTime() + 30 * 60 * 1000);
  return {
    title: 'Linirio meeting',
    start_at: toDatetimeLocal(start),
    end_at: toDatetimeLocal(end),
    attendees: '',
    description: '',
  };
}
